import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'

import InteractiveImage from './screens/InteractiveImage'
import PublicPages from './index'

const Routes = ({ history }) => (
  <ConnectedRouter history={history}>
    <PublicPages>
      <Switch>
        <Route exact path="/interactive-images/:interactiveImageId" component={InteractiveImage} />
      </Switch>
    </PublicPages>
  </ConnectedRouter>
)

Routes.propTypes = {
  history: PropTypes.object.isRequired,
}

export default Routes
